(() => {
  // app/scripts/product-description.js
  var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
  var cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;
  customElements.define("product-description-component", class productDescription extends HTMLElement {
    constructor() {
      super();
      let star_widgets = document.querySelectorAll(".product-review");
      star_widgets?.forEach((star_widget) => {
        star_widget.addEventListener("click", () => {
          if (window.innerWidth < 768) {
            let details = this.querySelectorAll(".tab-content--body");
            details.forEach((e) => {
              if (e.classList.contains("tab-reviews")) {
                e.querySelector("details").open = true;
                this.scrollIntoView(e);
              } else
                e.querySelector("details").open = false;
            });
          } else {
            let tab_qa = this.querySelector(".tab-reviews");
            if (tab_qa != null) {
              this.toggleTab(tab_qa);
              this.scrollIntoView(tab_qa);
            }
          }
        });
      });
      this.addEventListener("click", (e) => {
        const { target } = e;
        if (target.closest(".tab-content--heading")) {
          e.preventDefault();
          this.toggleTab(target);
        }
        if (target.closest(".jsScrollTo") && target.closest("sticky-component.active")) {
          e.preventDefault();
          this.scrollTo(target.closest(".jsScrollTo").dataset.scroll);
        }
        if (target.closest(".navigation-next")) {
          let next_element = this.querySelector(".tab-content--heading.active").nextElementSibling;
          if (next_element.getAttribute("aria-controls") != null) {
            this.toggleTab(next_element);
          } else {
            return;
          }
        }
        if (target.closest(".navigation-back")) {
          let prev_element = this.querySelector(".tab-content--heading.active").previousElementSibling;
          if (prev_element.getAttribute("aria-controls") != null) {
            this.toggleTab(prev_element);
          } else {
            return;
          }
        }
      });
    }
    toggleTab(element) {
      this.querySelectorAll(".tab-content--heading.active").forEach((button) => {
        const tabEl2 = this.querySelector(button.getAttribute("aria-controls"));
        button.classList.remove("active");
        tabEl2.classList.remove("active");
      });
      const tabEl = this.querySelector(element.getAttribute("aria-controls"));
      element.classList.add("active");
      tabEl.classList.add("active");
    }
    scrollTo(selector) {
      const targetOffsetTop = document.querySelector(selector).getBoundingClientRect().top + document.documentElement.scrollTop;
      const bottom = this.querySelector("sticky-component").getBoundingClientRect().top;
      window.scrollTo({
        top: targetOffsetTop - bottom,
        behavior: "smooth"
      });
    }
  });
})();
